'use client'

import { useTranslations } from 'next-intl'

import { cn, Slot } from '@/shared/lib'
import { Icon, TextField } from '@/shared/ui'

import { useDateRange } from '../../lib/date-range'
import { useKeyword } from '../../lib/keyword'

type Props = {
  keyword?: string
  startDate?: string
  endDate?: string
  onSearch: () => void
}

export const MobileKeywordSearchBar = ({
  keyword,
  startDate,
  endDate,
  onSearch,
}: Props) => {
  const t = useTranslations('search_result.search')

  const {
    keywordInputRef,
    value,
    handleKeywordInputChange,
    handleKeywordInputKeyDown,
    handleKeywordInputReset,
  } = useKeyword({ defaultValue: keyword, onEnterKeyDown: onSearch })

  const { dateRange, handleDateInputClick } = useDateRange({
    startDate,
    endDate,
  })

  return (
    <div className="flex h-[57px] gap-4 border-b border-b-gray-100 bg-white px-4 py-[3px]">
      <TextField
        ref={keywordInputRef}
        value={value}
        onChange={handleKeywordInputChange}
        onKeyDown={handleKeywordInputKeyDown}
        onReset={handleKeywordInputReset}
        placeholder={t('mobile_placeholder')}
        className="w-3/5 border-none bg-[rgba(0,0,0,0)] text-[15px]! leading-[22px]! *:placeholder:text-gray-400"
        padding={{
          x: 0,
          y: 13,
        }}
      >
        <Slot name="left">
          <Icon
            name="search"
            size={24}
            className="text-black"
            strokeWidth={1.5}
          />
        </Slot>
      </TextField>
      <TextField
        value={dateRange}
        onClick={handleDateInputClick}
        placeholder={t('mobile_dates')}
        readOnly
        tabIndex={-1}
        type="text"
        className={cn(
          'cursor-pointer border-none bg-[rgba(0,0,0,0)] text-[15px]! leading-[22px]!',
          '*:placeholder:text-gray-400 *:read-only:cursor-pointer',
          'w-2/5 shrink-0 focus-visible:outline-none',
        )}
        padding={{
          x: 0,
          y: 13,
        }}
      >
        <Slot name="left">
          <Icon
            name="calendar"
            className="text-black"
            size="24"
            strokeWidth={1.5}
          />
        </Slot>
      </TextField>
    </div>
  )
}
